import { AnimatePresence, motion } from "framer-motion";
import { cn } from "@/lib/utils";

export const Sheet = ({ open, onClose, isPhone, children, testid = "log-care-sheet" }) => (
  <AnimatePresence>
    {open && (
      <>
        <motion.div
          key="backdrop"
          data-testid="sheet-backdrop"
          className="absolute inset-0 z-40 bg-[rgba(24,18,12,0.38)] backdrop-blur-[2px]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        />
        <motion.div
          key="panel"
          role="dialog"
          aria-modal="true"
          data-testid={testid}
          className={cn(
            "absolute z-50 bg-paper overflow-y-auto",
            isPhone ? "inset-x-0 bottom-0 max-h-[94%] rounded-t-[32px]" : "right-0 top-0 bottom-0 w-[520px] border-l border-line"
          )}
          initial={isPhone ? { y: "100%" } : { x: "100%" }}
          animate={{ y: 0, x: 0 }}
          exit={isPhone ? { y: "100%" } : { x: "100%" }}
          transition={{ type: "spring", damping: 34, stiffness: 340 }}
        >
          {isPhone && <div className="mx-auto mt-3 h-1.5 w-12 rounded-full bg-line" />}
          {children}
        </motion.div>
      </>
    )}
  </AnimatePresence>
);
